import {SlButton, SlInput} from '@shoelace-style/shoelace/shoelace';
import {notNull} from '../../../../../../library/clxProductNet/assets/js/modules/common/assert';
import {MicroConversionTrackingEventsEnum} from '../../common/trackingMicroconversion/Model/EventProductCustomizationEnum';
import ProductCustomizationConfigModel from '../Model/productCustomizationConfigModel';
import CustomizationPricingOverviewComponent from './customizationPricingOverviewComponent';

export default class CustomizationAmountInputComponent extends HTMLElement {
    private config: ProductCustomizationConfigModel;
    private pricingOverview: CustomizationPricingOverviewComponent | null = null;

    constructor() {
        super();
        this.config = ProductCustomizationConfigModel.getInstance();
    }

    connectedCallback() {
        this.pricingOverview = document.querySelector<CustomizationPricingOverviewComponent>('#pricing-overview');
        this.attachUIEventListeners();
    }

    disconnectedCallback() {
        this.pricingOverview = null;
        this.detachUIEventListeners();
    }

    public async refreshOverviewUIAndHandleErrors(productCustomizationConfig: ProductCustomizationConfigModel, eventName: string): Promise<void> {
        await notNull(this.pricingOverview).refreshOverviewPricesAndHandleErrors(productCustomizationConfig, eventName);
    }

    private handleAmountChange = async () => {
        const amountInput = notNull(this.querySelector<SlInput>('.customization_amount'));

        if (isNaN(parseInt(amountInput.value)) || parseInt(amountInput.value) < parseInt(<string>amountInput.min)) {
            amountInput.value = <string>amountInput.min;
        }
        if (amountInput.dataset?.sku && amountInput.dataset?.groesseid) {
            this.config.setAmount(parseInt(amountInput.value), parseInt(amountInput.dataset?.sku), parseInt(amountInput.dataset?.groesseid));
            await this.refreshOverviewUIAndHandleErrors(this.config, MicroConversionTrackingEventsEnum.customization_configuration_change);
        }
    };

    private handleButtonIncreaseChange = () => {
        const amountInput = notNull(this.querySelector<SlInput>('.customization_amount'));
        amountInput.stepUp();
        // @ts-ignore
        amountInput.handleChange();
    };

    private handleButtonDecreaseChange = () => {
        const amountInput = notNull(this.querySelector<SlInput>('.customization_amount'));
        amountInput.stepDown();
        // @ts-ignore
        amountInput.handleChange();
    };

    private attachUIEventListeners(): void {
        const amountInput = notNull(this.querySelector<SlInput>('.customization_amount'));
        const buttonIncrease = notNull(this.querySelector<SlButton>('sl-button.increment'));
        const buttonDecrease = notNull(this.querySelector<SlButton>('sl-button.decrement'));

        if (amountInput && buttonIncrease && buttonDecrease) {
            amountInput.addEventListener('sl-change', this.handleAmountChange);
            buttonIncrease.addEventListener('click', this.handleButtonIncreaseChange);
            buttonDecrease.addEventListener('click', this.handleButtonDecreaseChange);

            if (amountInput.min === undefined) {
                amountInput.min = 0;
            }

            if (amountInput.value === amountInput.min.toString()) {
                buttonDecrease.disabled = true;
            } else {
                buttonDecrease.disabled = false;
            }
        }
    }

    private detachUIEventListeners(): void {
        const amountInput = notNull(this.querySelector<SlInput>('.customization_amount'));
        const buttonIncrease = notNull(this.querySelector<SlButton>('sl-button.increment'));
        const buttonDecrease = notNull(this.querySelector<SlButton>('sl-button.decrement'));

        if (amountInput && buttonIncrease && buttonDecrease) {
            amountInput.removeEventListener('sl-change', this.handleAmountChange);
            buttonIncrease.removeEventListener('click', this.handleButtonIncreaseChange);
            buttonDecrease.removeEventListener('click', this.handleButtonDecreaseChange);
        }
    }
}
customElements.define('clx-customization-amount-input', CustomizationAmountInputComponent);
